import React from 'react';
import { Button, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import Spinner from 'sama_global/components/Spinner/Spinner';

/* eslint-disable react/prop-types */

const useStyles = makeStyles(theme => ({
  root: {
    '&.Mui-disabled': {
      backgroundColor: theme.palette.common.pale,
    },
  },
  loading: {
    pointerEvents: 'none',
  },
  button: {
    minHeight: '36.5px',
  },
  container: {
    position: 'relative',
    '& > div': {
      position: 'absolute',
      right: '-25px',
      top: 0,
      bottom: 0,
      margin: 'auto',
      display: 'flex',
      alignItems: 'center',
      transition: '0.3s 0.2s',
      opacity: 1,
    },
  },
  fade: {
    opacity: '0 !important',
  },
}));

const StyledButton = ({ children, isLoading, ...props }) => {
  const classes = useStyles();
  return (
    <Button
      {...props}
      classes={{ root: classes.root }}
      className={clsx(classes.button, { [classes.loading]: isLoading })}
      color={props.color || 'primary'}
    >
      <div className={classes.container}>
        {children}
        <div className={clsx({ [classes.fade]: !isLoading })}>
          <Spinner />
        </div>
      </div>
    </Button>
  );
};

StyledButton.propTypes = {
  children: PropTypes.node.isRequired,
  isLoading: PropTypes.bool,
  ...Button.propTypes,
};
StyledButton.defaultProps = {
  isLoading: false,
};

export default StyledButton;
